import React from 'react';
import './login.component.scss';
import { connect } from 'react-redux';
import IStore from '../../../models/IStore';
import { ReduxProps } from '../../../models/ReduxProps';
import HandshakeModel from '../../../stores/handshake/models/HandshakeModel';
import { selectRequesting } from '../../../selectors/requesting/RequestingSelector';
import HandshakeAction from '../../../stores/handshake/HandshakeAction';
// import DynamicComponent from '../../../components/dynamic/dynamic.component';
import LoadingIndicator from '../../../components/loading-indicator/loading-indicator.component';
import queryString from 'query-string';
import Toast from '../../../components/toast/toast';
import GeolocationModel from 'stores/login/models/login/GeolocationModel';
import AuthContainer from '../auth/auth.container';

interface IProps {}
interface IState {
    readonly isLoadStyle: boolean;
    readonly showNavbar: boolean;
}
interface IRouteParams {}
interface IStateToProps {
    //readonly currentComponent: any;
    readonly isRequesting: boolean;
    readonly handshake: HandshakeModel | null;
    readonly banners: Object[] | null;
    readonly geolocation: GeolocationModel;
    readonly logo?: string;
    readonly logoFooter?: string;
}
const mapStateToProps = (state: IStore, ownProps: IProps): IStateToProps => ({
    //currentComponent: state.login.currentComponent,
    isRequesting: selectRequesting(state, [HandshakeAction.REQUEST_VALIDATE_HANDSHAKE]),
    handshake: state.handshake.handshake,
    banners: state.login.banner,
    geolocation: state.login.geolocation,
    logo: state.handshake.handshake?.assets?.logoValiu,
    logoFooter: state.handshake.handshake?.assets?.logoValiuFooter,
});

class LoginComponent extends React.Component<IProps & IStateToProps & ReduxProps<any, IRouteParams>, IState> {
    constructor(props: any) {
        super(props);
        this.state = { isLoadStyle: false, showNavbar: true };
    }

    componentDidMount() {
        const params = queryString.parse(this.props.location.search);

        if (params && params.signature && params.message) {
            var signature = params.signature as string;
            var message = params.message as string;
            this.props.dispatch(HandshakeAction.requestValidateHandshake(signature, message, 'login'));
        } else {
            this.props.history.push(`/not-found`);
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.isRequesting === false) {
            if (nextProps.handshake) {
                if (!this.state.isLoadStyle) {
                    var selector = document.querySelector('head');
                    if (selector) {
                        let application = nextProps.handshake?.loginUrls;
                        selector.innerHTML += `<link rel="stylesheet" href="${
                            application?.visualStyle?.length ? 'fxn-styles-default.css' : 'fxn-styles-default.css'
                        }" type="text/css"/>`;
                        this.setState({ isLoadStyle: true });
                    }
                }
            } else {
                this.props.history.push(`/not-found`);
            }
        }
    }

    render() {
        const { /*currentComponent,*/ isRequesting, handshake, geolocation } = this.props;

        return (
            <React.Fragment>
                {isRequesting === false && handshake && this.state.isLoadStyle ? (
                    <div className="main__login ">
                        {this.state.showNavbar && (
                            <div className="navbar-container">
                                <div className="img-container">
                                    <img alt="info" src={require('../../../assets/media/img/login/info.svg')} />
                                </div>
                                <div className="text">
                                    Te recordamos que en Banco Base no solicita por ningún medio información confidencial sobre sus clientes, tales
                                    como: Usuarios, Contraseñas y Números de cuenta.
                                </div>
                                <div className="close-icon" onClick={() => this.setState({ showNavbar: false })}>
                                    <img alt="close" src={require('../../../assets/media/img/login/close.svg')} />
                                </div>
                            </div>
                        )}
                        <AuthContainer />

                        <footer className="footer-container">
                            <div className="footer-login">
                                <div className="main__bannerFXd-component">
                                    <ul className="display__list-banner">
                                        {geolocation.isBlocked && <Toast geolocationBlock={geolocation.isBlocked} type="block" />}
                                        {!geolocation.userConsent && <Toast type="consent" />}
                                    </ul>
                                </div>
                                <div className="footer-container">
                                    <div>
                                        <img className="second-logo" src={this.props.logoFooter} alt="" />
                                    </div>
                                    <div>Copyright © 2023 Valiu</div>
                                    <div className="policies">Política de Privacidad</div>
                                    <div className="logo-base">
                                        Con el respaldo de Banco Base
                                        <div></div>
                                        <img
                                            className="logo-base"
                                            src={require('../../../assets/media/img/logo/logo-banco-base-3.svg')}
                                            alt="banco-base"
                                        />
                                    </div>
                                </div>

                                <div className="mobile">
                                    <div className="footer-container-mobile">
                                        <div>
                                            <div>
                                                <img className="second-logo" src={this.props.logoFooter} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="footer-container-mobile">
                                        <div>
                                            <div className="logo-base">
                                                Con el respaldo de Banco Base
                                                <div></div>
                                                <img
                                                    className="logo-base"
                                                    src={require('../../../assets/media/img/logo/logo-banco-base-3.svg')}
                                                    alt="banco-base"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="footer-container-mobile footer-container-border footer">
                                        <div>Copyright © 2023 Valiu</div>
                                        <div className="policies">Política de Privacidad</div>
                                    </div>
                                </div>
                            </div>
                        </footer>
                    </div>
                ) : (
                    <LoadingIndicator />
                )}
            </React.Fragment>
        );
    }

    public drawBanner(banners: any) {
        let elements: any[] = [];
        banners.forEach((value: any, key: any) => {
            elements.push(
                <li key={key} id={value.id} style={{ ...value.style }} className={value.className}>
                    {value.message}
                </li>
            );
        });
        return elements;
    }
}

export { LoginComponent as Unconnected };
export default connect(mapStateToProps)(LoginComponent);
